import isInboxRuleOptionEditState from './actions/helpers/isInboxRuleOptionEditState';
import resetInboxRuleEdit from './actions/resetInboxRuleEdit';
import saveInboxRuleEdit from './actions/saveInboxRuleEdit';
import InboxRulesFull from './components/InboxRulesFull';
import isInboxRuleEditValid from './utils/isInboxRuleEditValid';
import * as React from 'react';
var InboxRulesOption = {
    key: 'inboxRules',
    titleStringKey: 'optionTitle_inboxRules',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_inboxRules',
    fullOptionFormSettings: {
        render: function () { return React.createElement(InboxRulesFull, null); },
        isDirty: function () { return isInboxRuleOptionEditState(); },
        onSave: function () { return saveInboxRuleEdit(); },
        onDiscard: function () { return resetInboxRuleEdit(); },
        disableSave: function () { return !isInboxRuleEditValid(); },
        hideSaveDiscard: function () {
            return !isInboxRuleOptionEditState();
        },
    },
};
export default InboxRulesOption;
//# sourceMappingURL=InboxRulesOption.js.map